"use client";

import CompareFooterCTA from "./CompareFooterCTA";
import CompareHeader from "./CompareHeader";
import CompareTable from "./CompareTable";

/** Composes the Compare Units page. Theme-aware, bilingual, responsive. */
export default function CompareParent() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-ash dark:bg-ash dark:text-white">
      <CompareHeader />
      <main className="mx-auto w-full max-w-360 flex-grow px-6 py-12 lg:px-10">
        <CompareTable />
      </main>
      <CompareFooterCTA />
    </div>
  );
}
